import React from 'react';
import App from './privacyComponent';


export default function(){
    return <App></App>;
}